<template>
  <section class="hero is-primary is-fullheight has-text-centered">
    <div class="hero-body">
      <img class="hero-typography" alt="" :src="cover"/>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'hero',
  computed: {
    ...mapGetters(['chapter']),
    cover () {
      return require(`@/assets/images/${this.chapter.shortname}/cover.svg`)
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100%;
}

.hero-body {
  padding: 0;
}

.hero-typography {
  height: 100vh;
  margin: 30px auto 0;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/Hero.vue?99dbc0b8